import classNames from 'classnames'
import { useCallback } from 'react'
import FaqList from 'src/components/FaqList'

import CarriersInfoNormal from 'src/components/carriersPage/carriersInfoNormal'
import useI18n from 'src/hooks/use_i18n'
import { AllCarriersInfoDTO, CarrierInfoMarkDTO, CmsCarrier, FaqItem } from 'src/types'
import { filterRegex } from 'src/utils/carriers_info'
import WhatCanWeDo from '../carriersInfoNormal/whatcanwedo'
import styles from './index.module.scss'

interface Props {
  carrier: AllCarriersInfoDTO
  carriersDataType: string // 定义页面性质
  carriersInfoData: any
  totalCarriersStr: number | string
  carrierInfoMark: CarrierInfoMarkDTO
  carrierName: string
  country: string
  cmsCarrier: CmsCarrier
}
interface H2ListItem {
  text: string
  id: string
}

type Render = (content: string, faq: FaqItem[]) => React.ReactElement

export default function Content({
  carrier,
  cmsCarrier,
  carriersDataType,
  carriersInfoData,
  totalCarriersStr,
  carrierInfoMark,
  carrierName,
  country
}: Props) {
  const { i18nFormatAll, activeLocale: locale } = useI18n()
  const renderCmsContent: Render = useCallback(
    (content, faq) => {
      // 将内容中的占位符进行替换
      const contentFormat = i18nFormatAll(content, {
        carriersName: carrierName,
        carriersNum: totalCarriersStr
      })
      // 将faq中的占位符进行替换
      const faqFormat = (faq || []).map((val) => ({
        ...val,
        title: i18nFormatAll(val.title, {
          carriersName: carrierName,
          carriersNum: totalCarriersStr
        }),
        content: i18nFormatAll(val.content, {
          carriersName: carrierName,
          carriersNum: totalCarriersStr
        })
      }))
      const h2List: H2ListItem[] = [] // 锚链接
      // 提取 H2 标签内容的正则表达式
      const h2Regex = /<h2>(.*?)<\/h2>/g
      const contentWithIds = contentFormat.replace(h2Regex, (_, text) => {
        const id = filterRegex(text, /[ ?]/g, '-')
        h2List.push({ text, id })
        return `<h2 id=${id}>${text}</h2>`
      })
      // 提取 FAQ 列表中的 H2 的锚链接
      const h2Faq: H2ListItem[] = faqFormat
        .filter((val) => val.uiType === 'h2')
        .map(({ title }) => ({ text: title, id: filterRegex(title, /[ ?]/g, '-') }))
      return (
        <section className={styles.main}>
          <div className={styles.nav}>
            {[...h2List, ...h2Faq].map(({ text, id }) => {
              return (
                <a key={id} href={`#${id}`}>
                  {text}
                </a>
              )
            })}
          </div>
          <div
            className={styles.content}
            dangerouslySetInnerHTML={{
              __html: contentWithIds
            }}
          />
          <FaqList qaList={faqFormat || []}>
            {/* what is different 通用模板第二段 */}
            {/* <WhatDifferent totalCarriersStr={totalCarriersStr} carrierName={carrierName} /> */}
            {/* why integrate 通用模板第四段 */}
            {/* <WhyIntegrate carrierName={carrierName} /> */}
            {/* who is using 通用模板第五段 */}
            {/* <WhoIsUse carrierInfoMark={carrierInfoMark} totalCarriersStr={totalCarriersStr} carrierName={carrierName} /> */}
          </FaqList>
          {/* 广告位 国内不展示广告位2024-11-27*/}
          {country === 'CN' ? null : (
            <section className={classNames('ad-slot', styles.gadContainer)} id="V6-Carriers-Bottom"></section>
          )}
          <div style={{ marginTop: '36px' }}>
            <WhatCanWeDo carrierName={carrierName} />
          </div>
        </section>
      )
    },
    [locale]
  )

  /*-----------当前语言与内容语言相同  --------------*/
  if (cmsCarrier?.language === locale) {
    // cms 有内容
    if (cmsCarrier?.content && cmsCarrier?.content !== '<p><br></p>') {
      return renderCmsContent(cmsCarrier?.content, [...(cmsCarrier?.faq || []), ...(cmsCarrier?.template?.faq || [])])
    }
  }

  // 本地有内容
  if (locale === 'en' && carriersDataType === 'seo' && JSON.stringify(carriersInfoData) !== '{}') {
    return (
      <section className={styles.main}>
        <CarriersInfoNormal
          carriersDataType={carriersDataType}
          carriersInfoData={carriersInfoData}
          carrier={carrier}
          totalCarriersStr={totalCarriersStr}
          carrierInfoMark={carrierInfoMark}
          carrierName={carrierName}
          country={country}
        />
      </section>
    )
  }

  /*-----------当前语言与内容语言不同  --------------*/

  // 模版语言与当前语言相同
  if (cmsCarrier?.template?.language === locale) {
    // cms 模版内容
    if (cmsCarrier?.template?.template_content && cmsCarrier?.template?.template_content !== '<p><br></p>') {
      return renderCmsContent(cmsCarrier?.template?.template_content, [
        ...(cmsCarrier?.faq || []),
        ...(cmsCarrier?.template?.faq || [])
      ])
    }
  }

  /*-----------都不同--------------*/

  // cms 有内容
  if (cmsCarrier?.content && cmsCarrier?.content !== '<p><br></p>') {
    return renderCmsContent(cmsCarrier?.content, [...(cmsCarrier?.faq || []), ...(cmsCarrier?.template?.faq || [])])
  }

  // cms 模版内容
  if (cmsCarrier?.template?.template_content && cmsCarrier?.template?.template_content !== '<p><br></p>') {
    return renderCmsContent(cmsCarrier?.template?.template_content, [
      ...(cmsCarrier?.faq || []),
      ...(cmsCarrier?.template?.faq || [])
    ])
  }

  // 兜底处理
  return (
    <section className={styles.main}>
      <CarriersInfoNormal
        carriersDataType={carriersDataType}
        carriersInfoData={carriersInfoData}
        carrier={carrier}
        totalCarriersStr={totalCarriersStr}
        carrierInfoMark={carrierInfoMark}
        carrierName={carrierName}
        country={country}
      />
    </section>
  )
}
